module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/flat-lays/flat-lay-04-02f161430ee1839b45b4379571ed1609.jpg";